import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Layout3dComponent } from './layout3d.component';
import { BoxChildComponent } from './components/box-child/box-child.component';
import { BoxChildDirective } from './directives/box-child.directive';
import { SmallTriangleComponent } from './components/small-triangle/small-triangle.component';
import { SmallBoxComponent } from './components/small-box/small-box.component';



@NgModule({
  declarations: [Layout3dComponent, BoxChildComponent, BoxChildDirective, SmallTriangleComponent, SmallBoxComponent],
  imports: [
    CommonModule
  ],
  exports: [Layout3dComponent]
})
export class Layout3dModule { }
